export const ChatGptConnectorTypeDecorator = {
  url() {
    return `signup-hubspot/integrations`;
  },
  query() {
    return {
      integration: 'chat-gpt-connector'
    };
  }
};